import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { RouterOutlet } from "@angular/router";
import { AuthService } from "@lib/auth/interfaces/IAuthService";
import { LanguagesService } from "@lib/base/services/languages.service";
import { ResizeWindowService } from "@lib/base/services/resize-window.service";

@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    private matIconRegistry = inject(MatIconRegistry);
    private resizeService = inject(ResizeWindowService);
    private languagesService = inject(LanguagesService);
    private authService = inject(AuthService);

    ngOnInit() {
        this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
        this.languagesService.init();
        this.authService.init();
    }
}
